module.exports = __webpack_public_path__ + "img/swimming-pool.22eb0463.svg";